import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  AdminApiPaths,
  APIDataProvider,
  TApiPaginationResponse,
  TApiResponse,
} from '../../../api';
import { IOneToOneTutorRate } from '.';

export type TAdminCreateOneToOneTutorRate = {
  tutorCountry: string;
  studentCountry: string;
  studentType: string;
  amounts: Array<{
    version: string;
    amount: number;
    currency: string;
  }>;
};

export type TAdminGetOneToOneTutorRates = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
  tutorCountry?: string;
  studentCountry?: string;
  studentType?: string;
};

export type TAdminUpdateOneToOneTutorRate = {
  id: string;
  tutorCountry: string;
  studentCountry: string;
  studentType: string;
  amounts: Array<{
    version: string;
    amount: number;
    currency: string;
  }>;
};

export type TAdminGetUserOneToOneTutorRates = {
  userId: string;
};

const apiDataProvider = new APIDataProvider();

const adminGetOneToOneTutorRatesModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
  tutorCountry,
  studentCountry,
  studentType,
}: TAdminGetOneToOneTutorRates) => {
  let path = `${AdminApiPaths.oneToOneTutorRates}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  if (tutorCountry) {
    path += `&tutorCountry=${tutorCountry}`;
  }

  if (studentCountry) {
    path += `&studentCountry=${studentCountry}`;
  }

  if (studentType) {
    path += `&studentType=${studentType}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IOneToOneTutorRate>>
  >(path);

  return response.data;
};

export const adminGetOneToOneTutorRates = createAsyncThunk(
  '/admin/one-to-one-tutor-rates/list',
  adminGetOneToOneTutorRatesModule
);

export const adminCreateOneToOneTutorRate = createAsyncThunk(
  '/admin/one-to-one-tutor-rates/create',
  async (data: TAdminCreateOneToOneTutorRate) => {
    const path = `${AdminApiPaths.oneToOneTutorRates}`;

    const response = await apiDataProvider.post<
      TApiResponse<IOneToOneTutorRate>
    >(path, data);

    return response.data;
  }
);

export const adminUpdateOneToOneTutorRate = createAsyncThunk(
  '/admin/one-to-one-tutor-rates/update',
  async (data: TAdminUpdateOneToOneTutorRate) => {
    const path = `${AdminApiPaths.oneToOneTutorRates}/${data.id}`;

    const response = await apiDataProvider.put<
      TApiResponse<IOneToOneTutorRate>
    >(path, data);

    return response.data;
  }
);

export const adminDeleteOneToOneTutorRate = createAsyncThunk(
  '/admin/one-to-one-tutor-rates/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.oneToOneTutorRates}/${id}`;

    const response = await apiDataProvider.delete<
      TApiResponse<IOneToOneTutorRate>
    >(path);

    return response.data;
  }
);

export const getUserOneToOneTutorRatesAsAdmin = createAsyncThunk(
  '/admin/user/one-to-one-tutor-rates/user/list',
  async ({ userId }: TAdminGetUserOneToOneTutorRates) => {
    const path = `${AdminApiPaths.oneToOneTutorRates}/user/${userId}?userId=${userId}`;

    const response = await apiDataProvider.get<
      TApiResponse<IOneToOneTutorRate[]>
    >(path);

    return response.data;
  }
);
